import React, {Component} from "react";
import tiktok_logo from '../../images/tiktok-logo-v2.png';
import tiktok_logo_with_padding from '../../images/tiktok-logo-with-padding.png';
import tiktok_logo_off from '../../images/tiktok-logo-v2-off.png';
import tiktok_logo_colorfully from '../../images/tiktok_logo_colorfully_v2.png';

export class TiktokLogo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isHovered: false
        };
    }

    getRenderVeryColoredVersion() {
        if(this.props.renderVeryColoredVersion)
            return this.props.renderVeryColoredVersion;
        return false;
    }

    getIsColoredOnHover() {
        if(this.props.isColoredOnHover)
            return this.props.isColoredOnHover;
        return false;
    }

    handleMouseEnter = () => {
        this.setState({ isHovered: true });
    }

    handleMouseLeave = () => {
        this.setState({ isHovered: false });
    }

    getHspace() {
        if(this.props.hspace !== undefined)
            return this.props.hspace;
        return 10;
    }

    getVspace() {
        if(this.props.vspace !== undefined)
            return this.props.vspace;
        return 10;
    }

    getWidth() {
        return this.props.width || 20;
    }

    getHeight() {
        return this.props.height || 20;
    }



    getImage() {
        if(this.getRenderVeryColoredVersion())
            return tiktok_logo_colorfully;
        if(this.props.useLogoImageWithPadding === true)
            return tiktok_logo_with_padding;
        return !this.getIsColoredOnHover() || this.state.isHovered ? tiktok_logo : tiktok_logo_off;
    }

    render() {
        return <img alt="TikTok Ads" style={this.props.styles} src={this.getImage()} height={this.getHeight()}
                    width={this.getWidth()} hspace={this.getHspace()} vspace={this.getVspace()}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
        />
    }
}
